import { render, staticRenderFns } from "./SupportTicketReplyButton.vue?vue&type=template&id=92dee6ec&"
import script from "./SupportTicketReplyButton.vue?vue&type=script&lang=js&"
export * from "./SupportTicketReplyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports